import { useCallback } from 'react';

// @ts-expect-error: no types
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import getKnowledgeUrl from 'forms-utils-lib/urls/app/getKnowledgeUrl';
import { HOW_DO_I_TEST_MY_HUBSPOT_FORM_FOR_ISSUES } from 'FormsCommonComponents/constants/KCSArticlePaths';
import EmbedVersions from 'forms-utils-lib/constants/formDefinition/EmbedVersions';
import ShareLinkTokenVersions from 'forms-utils-lib/constants/formDefinition/ShareLinkTokenVersions';
import { getPropertyValue } from 'marketing-platform-lib/utils/crmUtils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H2 } from 'foundations-components/transitional/components/H2';
import { FORM_ACTION_IDS } from 'asset-actions-lib-forms/constants/actionIds';
import useShareLink from '../share/hooks/useShareLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ViewFormModal({
  onClose,
  onConfirm,
  crmObject
}) {
  const formGuid = getPropertyValue(crmObject, 'hs_form_id');
  const createdAt = parseInt(getPropertyValue(crmObject, 'hs_created_at') || '0', 10) || 0;
  const embedVersion = getPropertyValue(crmObject, 'hs_embed_version');
  const shareableLink = useShareLink(formGuid, {
    version: ShareLinkTokenVersions[embedVersion] || ShareLinkTokenVersions[EmbedVersions.V3],
    createdAt
  });
  const handleClick = useCallback(() => {
    onConfirm(FORM_ACTION_IDS.VIEW);
  }, [onConfirm]);
  return /*#__PURE__*/_jsxs(Modal, {
    onEsc: onClose,
    width: 500,
    size: "auto",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.modals.testForm.title"
        })
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.modals.testForm.message"
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "assetActionsLibForms.modals.testForm.troubleshooting",
          options: {
            learnMoreLink: /*#__PURE__*/_jsx(KnowledgeBaseButton, {
              url: `${getKnowledgeUrl()}/${HOW_DO_I_TEST_MY_HUBSPOT_FORM_FOR_ISSUES}`
            })
          }
        })
      })]
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        use: "primary",
        external: true,
        href: shareableLink,
        onClick: handleClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.modals.testForm.viewForm"
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: onClose,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLib.modals.shared.closeButton"
        })
      })]
    })]
  });
}